export enum MeetingType {
  Jicoo = 1,
  Zoom = 2,
  GoogleMeet = 3,
  Teams = 4,
}

export const meetingTypeName = (meetingType: MeetingType) => {
  switch (meetingType) {
    case MeetingType.Zoom:
      return 'Zoom';
    case MeetingType.GoogleMeet:
      return 'Google Meet';
    case MeetingType.Teams:
      return 'Teams';
  }
};

export const createTrackEventName = (meetingType: MeetingType) => {
  switch (meetingType) {
    case MeetingType.Zoom:
      return 'create zoom meeting';
    case MeetingType.GoogleMeet:
      return 'create google meet meeting';
    case MeetingType.Teams:
      return 'create teams meeting';
  }
  return 'create unknown source meeting';
};
